import { render, staticRenderFns } from "./nzz.vue?vue&type=template&id=24ccf51a&scoped=true"
import script from "./nzz.vue?vue&type=script&lang=js"
export * from "./nzz.vue?vue&type=script&lang=js"
import style0 from "./nzz.vue?vue&type=style&index=0&id=24ccf51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccf51a",
  null
  
)

export default component.exports